// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .css-198uoyh-MuiFormControlLabel-root,.css-bq1b2p-MuiTypography-root,.css-1qlvjsd-MuiTypography-root,.css-k0xfey-MuiTypography-root,.css-1hps5ya-MuiFormLabel-root-MuiInputLabel-root,.css-yjsfm1,.css-1y2jrxa-MuiInputBase-input-MuiOutlinedInput-input{
  color:white !important;
  -webkit-text-fill-color: #ffffff !important;
} */
/* .css-1d3z3hw-MuiOutlinedInput-notchedOutline{
border-color: white !important;
} */
/* .css-1rm7squ{
  background-color: transparent !important;
} */
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Authentication.css"],"names":[],"mappings":"AAAA;;;GAGG;AACH;;GAEG;AACH;;GAEG","sourcesContent":["/* .css-198uoyh-MuiFormControlLabel-root,.css-bq1b2p-MuiTypography-root,.css-1qlvjsd-MuiTypography-root,.css-k0xfey-MuiTypography-root,.css-1hps5ya-MuiFormLabel-root-MuiInputLabel-root,.css-yjsfm1,.css-1y2jrxa-MuiInputBase-input-MuiOutlinedInput-input{\n  color:white !important;\n  -webkit-text-fill-color: #ffffff !important;\n} */\n/* .css-1d3z3hw-MuiOutlinedInput-notchedOutline{\nborder-color: white !important;\n} */\n/* .css-1rm7squ{\n  background-color: transparent !important;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
